import { CreateNewVoucherForm } from './create-new-voucher-form'

export const CreateNewVoucherMainNZ = ({
  onCloseModal,
}: {
  onCloseModal: () => void
}) => {
  return <CreateNewVoucherForm onCloseModal={onCloseModal} />
}
